import clsx from "clsx";
import { useEffect, useState } from "react";

import { Icon } from "~/assets/icons/Icon";

import Button from "../../../ui/button/Button";
import styles from "./PendingLoader.module.scss";

const PROGRESS_LIMIT_MAX = 100;
const PROGRESS_LIMIT_MIN = 0;

const runProgress = (fn: (value: number) => void, value: number): void => {
  setTimeout(() => {
    fn(value + 1);
  }, 1000);
};
type PendingLoaderPtops = {
  isPendingLoader: boolean;
  onSkip: () => void;
};
const PendingLoader = ({ isPendingLoader, onSkip }: PendingLoaderPtops) => {
  const [progress, setProgress] = useState(PROGRESS_LIMIT_MIN);

  useEffect(() => {
    if (progress < PROGRESS_LIMIT_MAX && !isPendingLoader) {
      runProgress(setProgress, progress);
    }
    if (progress === PROGRESS_LIMIT_MAX && !isPendingLoader) {
      setProgress(PROGRESS_LIMIT_MIN);
    }
  }, [progress, isPendingLoader]);

  return (
    <div className={styles.pendingLoader}>
      <div className={styles.pendingLoaderSection}>
        <div className={styles.pendingLoaderImageText}>
          <Icon iconName="PendingProcessPic" width="11.5rem" height="7.5rem" />
        </div>
        <div className={styles.pendingLoaderInfo}>
          <div className={styles.pendingLoaderInfoTitle}>
            We're Analyzing Your Keywords
          </div>
          <div className={styles.pendingLoaderInfoDescr}>
            We are looking for the best keywords — this can take a moment. You
            can skip for now and add keywords anytime later.
          </div>
        </div>
        <div className={styles.pendingLoaderProgressBar}>
          <div className={styles.cssProgress}>
            <div className={styles.progress1}>
              <div
                className={clsx(
                  styles.cssProgressBar,
                  styles.cssProgressActive,
                )}
                data-percent="100"
                style={{ width: "100%" }}
              ></div>
            </div>
          </div>
        </div>
        <div className={styles.pendingLoaderActions}>
          <Button outlined onClick={onSkip}>
            Skip for Now
          </Button>
        </div>
      </div>
    </div>
  );
};
export default PendingLoader;
